(function () {
  var dataEl = document.getElementById('eltempo-filter-data');
  if (!dataEl) return;
  var products;
  try { products = JSON.parse(dataEl.textContent); } catch (e) { return; }
  if (!Array.isArray(products) || !products.length) return;

  products.forEach(function (p) { p.s = Array.isArray(p.s) ? p.s : []; });

  var filters = { vendor: [], k: [], u: [], m: [], r: [], s: [] };

  function cardMap() {
    var map = {};
    document.querySelectorAll('[data-product-handle]').forEach(function (el) {
      map[el.dataset.productHandle] = el;
    });
    return map;
  }

  function matches(p) {
    if (filters.vendor.length && filters.vendor.indexOf(p.vendor) < 0) return false;
    if (filters.k.length && filters.k.indexOf(p.k) < 0) return false;
    if (filters.u.length && filters.u.indexOf(p.u) < 0) return false;
    if (filters.m.length && filters.m.indexOf(p.m) < 0) return false;
    if (filters.r.length && filters.r.indexOf(p.r) < 0) return false;
    if (filters.s.length && !filters.s.some(function (sz) { return p.s.indexOf(sz) >= 0; })) return false;
    return true;
  }

  function matchesExcept(p, excl) {
    var dims = ['vendor', 'k', 'u', 'm', 'r', 's'];
    for (var i = 0; i < dims.length; i++) {
      var d = dims[i];
      if (d === excl || !filters[d].length) continue;
      if (d === 's') {
        if (!filters.s.some(function (sz) { return p.s.indexOf(sz) >= 0; })) return false;
      } else {
        if (filters[d].indexOf(p[d]) < 0) return false;
      }
    }
    return true;
  }

  function availableVals(dim) {
    var set = {};
    products.forEach(function (p) {
      if (!matchesExcept(p, dim)) return;
      if (dim === 's') { p.s.forEach(function (sz) { if (sz) set[sz] = true; }); }
      else { if (p[dim]) set[p[dim]] = true; }
    });
    return set;
  }

  function countWith(dim, val) {
    var f = {};
    Object.keys(filters).forEach(function (d) { f[d] = filters[d].slice(); });
    if (f[dim].indexOf(val) < 0) f[dim].push(val);
    return products.filter(function (p) {
      if (f.vendor.length && f.vendor.indexOf(p.vendor) < 0) return false;
      if (f.k.length && f.k.indexOf(p.k) < 0) return false;
      if (f.u.length && f.u.indexOf(p.u) < 0) return false;
      if (f.m.length && f.m.indexOf(p.m) < 0) return false;
      if (f.r.length && f.r.indexOf(p.r) < 0) return false;
      if (f.s.length && !f.s.some(function (sz) { return p.s.indexOf(sz) >= 0; })) return false;
      return true;
    }).length;
  }

  function totalActive() {
    return Object.keys(filters).reduce(function (n, k) { return n + filters[k].length; }, 0);
  }

  function applyVisibility() {
    var map = cardMap();
    var count = 0;
    products.forEach(function (p) {
      var card = map[p.handle];
      if (!card) return;
      var show = matches(p);
      card.style.display = show ? '' : 'none';
      if (show) count++;
    });
    return count;
  }

  var SIZE_ORDER = ['XXS', 'XS', 'S', 'M', 'L', 'XL', 'XXL'];
  function sortSizes(arr) {
    return arr.sort(function (a, b) {
      var ai = SIZE_ORDER.indexOf(a), bi = SIZE_ORDER.indexOf(b);
      if (ai < 0 && bi < 0) return a < b ? -1 : 1;
      if (ai < 0) return 1;
      if (bi < 0) return -1;
      return ai - bi;
    });
  }

  function allVals(dim) {
    var set = {};
    products.forEach(function (p) {
      if (dim === 's') { p.s.forEach(function (sz) { if (sz) set[sz] = true; }); }
      else { if (p[dim]) set[p[dim]] = true; }
    });
    var arr = Object.keys(set);
    return dim === 's' ? sortSizes(arr) : arr.sort();
  }

  var panel = null;

  function renderPanel() {
    if (!panel) return;
    panel.innerHTML = '';
    var dims = [
      { k: 'vendor', label: 'Merke' },
      { k: 'k', label: 'Kategori' },
      { k: 'u', label: 'Underkategori' },
      { k: 'm', label: 'Modellserie' },
      { k: 'r', label: 'Rammemateriale' },
      { k: 's', label: 'Størrelse' }
    ];
    var form = document.createElement('div');
    form.className = 'eltempo-filter-form';

    dims.forEach(function (dim) {
      var vals = allVals(dim.k);
      if (!vals.length) return;
      var avail = availableVals(dim.k);
      var active = filters[dim.k];

      var group = document.createElement('div');
      group.className = 'eltempo-filter-group';
      var h4 = document.createElement('h4');
      h4.textContent = dim.label;
      group.appendChild(h4);
      h4.addEventListener('click', function () { group.classList.toggle('collapsed'); });

      var optsDiv = document.createElement('div');
      optsDiv.className = 'eltempo-filter-options';

      vals.forEach(function (val) {
        var isAvail = !!avail[val];
        var isActive = active.indexOf(val) >= 0;
        var cnt = (isAvail || isActive) ? countWith(dim.k, val) : 0;

        var lbl = document.createElement('label');
        lbl.className = 'eltempo-filter-option' + (!isAvail && !isActive ? ' disabled' : '');
        var cb = document.createElement('input');
        cb.type = 'checkbox';
        cb.checked = isActive;
        (function (v, dk) {
          cb.addEventListener('change', function () {
            var idx = filters[dk].indexOf(v);
            if (cb.checked) { if (idx < 0) filters[dk].push(v); }
            else { if (idx >= 0) filters[dk].splice(idx, 1); }
            renderPanel();
            var n = applyVisibility();
            updateBadge();
            var ftr = document.getElementById('eltempo-filter-footer');
            if (ftr) {
              var sb = ftr.querySelector('.btn--primary');
              if (sb) sb.textContent = 'Vis ' + n + ' produkter';
            }
          });
        })(val, dim.k);

        var nameSpan = document.createElement('span');
        nameSpan.textContent = val;
        var cntSpan = document.createElement('span');
        cntSpan.className = 'option-count';
        if (cnt) cntSpan.textContent = '(' + cnt + ')';

        lbl.appendChild(cb);
        lbl.appendChild(nameSpan);
        lbl.appendChild(cntSpan);
        optsDiv.appendChild(lbl);
      });

      group.appendChild(optsDiv);
      form.appendChild(group);
    });

    panel.appendChild(form);

    if (totalActive() > 0) {
      var n = applyVisibility();
      var footer = document.createElement('div');
      footer.id = 'eltempo-filter-footer';
      footer.className = 'eltempo-filter-footer';
      var showBtn = document.createElement('button');
      showBtn.className = 'btn btn--primary';
      showBtn.textContent = 'Vis ' + n + ' produkter';
      showBtn.addEventListener('click', function () {
        var cl = document.querySelector('.js-drawer-close');
        if (cl) cl.click();
      });
      var resetBtn = document.createElement('button');
      resetBtn.className = 'btn btn--secondary';
      resetBtn.textContent = 'Nullstill';
      resetBtn.addEventListener('click', function () {
        Object.keys(filters).forEach(function (d) { filters[d] = []; });
        renderPanel();
        applyVisibility();
        updateBadge();
      });
      footer.appendChild(showBtn);
      footer.appendChild(resetBtn);
      panel.appendChild(footer);
    }
  }

  function updateBadge() {
    var n = totalActive();
    var btn = document.querySelector('.js-drawer-open-collection-filters');
    if (!btn) return;
    var badge = btn.querySelector('.eltempo-badge');
    if (n > 0) {
      if (!badge) { badge = document.createElement('span'); badge.className = 'eltempo-badge'; btn.appendChild(badge); }
      badge.textContent = ' (' + n + ')';
    } else if (badge) { badge.remove(); }
  }

  function init() {
    var drawer = document.getElementById('FilterDrawer');
    if (!drawer) return;
    panel = drawer.querySelector('.drawer__scrollable');
    if (!panel) return;

    var style = document.createElement('style');
    style.textContent =
      '.collection-filter__item--drawer{display:block!important}' +
      '#FilterDrawer .eltempo-filter-form{padding:0 20px 20px}' +
      '#FilterDrawer .eltempo-filter-group{margin-bottom:20px}' +
      '#FilterDrawer .eltempo-filter-group h4{font-size:13px;font-weight:700;text-transform:uppercase;letter-spacing:.08em;margin:0 0 10px;padding-bottom:8px;border-bottom:1px solid #e8e8e8;cursor:pointer;display:flex;justify-content:space-between;align-items:center;user-select:none}' +
      '#FilterDrawer .eltempo-filter-group h4::after{content:"\u25BE";font-size:10px;margin-left:8px}' +
      '#FilterDrawer .eltempo-filter-group.collapsed h4::after{content:"\u25B8"}' +
      '#FilterDrawer .eltempo-filter-group.collapsed .eltempo-filter-options{display:none}' +
      '#FilterDrawer .eltempo-filter-option{display:flex;align-items:center;gap:8px;padding:5px 0;cursor:pointer;font-size:14px;line-height:1.3}' +
      '#FilterDrawer .eltempo-filter-option.disabled{opacity:.35;pointer-events:none}' +
      '#FilterDrawer .eltempo-filter-option input{width:16px;height:16px;flex-shrink:0;cursor:pointer}' +
      '#FilterDrawer .eltempo-filter-option .option-count{margin-left:auto;font-size:12px;color:#888}' +
      '#FilterDrawer .eltempo-filter-footer{padding:16px 20px;border-top:1px solid #e8e8e8;display:flex;gap:10px}' +
      '#FilterDrawer .eltempo-filter-footer .btn{flex:1;text-align:center;font-size:13px;padding:10px 8px}';
    document.head.appendChild(style);

    renderPanel();
    applyVisibility();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
